"use client"
import React, { useState, useEffect, useRef } from "react";

import dynamic from 'next/dynamic';

const Footer = dynamic(() => import('@/Component/Footer'), { ssr: true });
const Header = dynamic(() => import('@/Component/Header'), { ssr: true });
const FadeInSection = dynamic(() => import('@/Component/Hooks/FadeInSection'), { ssr: true });
const TitleText = dynamic(() => import('@/Component/TitleText'), { ssr: true });

import styles from "./AboutUsPage.module.css"
import { useTranslation } from "react-i18next";
//import { interpolate } from 'flubber'
import lay from "@/assets/Character/Lay.webp";
import blue from "@/assets/Character/Blue.webp";
import logo from "@/assets/logo/BePex_Logo.webp"
import download from "@/assets/Icon/Download_Icon.png"
import { useLoading } from "@/Component/LoadingContext";
import Image from "next/image"
const symbolData = [
    {
        content: [
            "M26 0C26.8827 13.9775 38.0224 25.1174 52 26C38.0224 26.8827 26.8827 38.0224 26 52C25.1174 38.0224 13.9775 26.8827 0 26C13.9775 25.1174 25.1174 13.9775 26 0Z",
            "M26.0283 0L29.9008 14.0814L41.3106 4.96556L36.1668 18.6339L50.7556 17.9656L38.5603 26L50.7556 34.0345L36.1668 33.3661L41.3106 47.0345L29.9008 37.9187L26.0283 52L22.1556 37.9187L10.7458 47.0345L15.8896 33.3661L1.30078 34.0345L13.4963 26L1.30078 17.9656L15.8896 18.6339L10.7458 4.96556L22.1556 14.0814L26.0283 0Z",
        ],
        duration: 60,
        delay: 1000,
        svg_className: "symbol__img"
    },
    {
        content: [
            "M28.6 0C30.036 0 31.2 1.16406 31.2 2.6V7.16914C31.2 9.48548 34.0005 10.6455 35.6385 9.0076L38.8692 5.77673C39.8848 4.76138 41.5308 4.76138 42.5464 5.77673L46.2233 9.4537C47.2386 10.4691 47.2386 12.1153 46.2233 13.1306L42.9923 16.3615C41.3546 17.9994 42.5144 20.8 44.8308 20.8H49.4C50.836 20.8 52 21.964 52 23.4V28.6C52 30.036 50.836 31.2 49.4 31.2H44.8308C42.5144 31.2 41.3546 34.0005 42.9923 35.6385L46.2233 38.8692C47.2386 39.8848 47.2386 41.5308 46.2233 42.5464L42.5464 46.2233C41.5308 47.2386 39.8848 47.2386 38.8692 46.2233L35.6385 42.9923C34.0005 41.3546 31.2 42.5144 31.2 44.8308V49.4C31.2 50.836 30.036 52 28.6 52H23.4C21.964 52 20.8 50.836 20.8 49.4V44.8308C20.8 42.5144 17.9994 41.3546 16.3615 42.9923L13.1306 46.2233C12.1153 47.2386 10.4691 47.2386 9.4537 46.2233L5.77676 42.5464C4.76138 41.5308 4.76138 39.8848 5.77676 38.8692L9.00762 35.6385C10.6455 34.0005 9.4855 31.2 7.16914 31.2H2.6C1.16406 31.2 0 30.036 0 28.6L0 23.4C0 21.964 1.16406 20.8 2.6 20.8H7.16914C9.48548 20.8 10.6455 17.9994 9.00762 16.3615L5.77676 13.1306C4.76138 12.1153 4.76138 10.4691 5.77676 9.4537L9.4537 5.77673C10.4691 4.76138 12.1153 4.76138 13.1306 5.77673L16.3615 9.0076C17.9994 10.6455 20.8 9.48548 20.8 7.16914V2.6C20.8 1.16406 21.964 0 23.4 0L28.6 0ZM26 39C33.1796 39 39 33.1796 39 26C39 18.8203 33.1796 13 26 13C18.8203 13 13 18.8203 13 26C13 33.1796 18.8203 39 26 39Z"
        ],
        duration: 60,
        delay: 1000,
        svg_className: "symbol__img",
        path_className: "symbol__path__rotate"
    },
    {
        content: [
            "M26 52C40.3593 52 52 40.3593 52 26C52 11.6406 40.3593 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3593 11.6406 52 26 52ZM26 37.375C32.2821 37.375 37.375 32.2821 37.375 26C37.375 19.7177 32.2821 14.625 26 14.625C19.7177 14.625 14.625 19.7177 14.625 26C14.625 32.2821 19.7177 37.375 26 37.375Z",
            "M25.9985 47.7649C27.7631 49.8826 29.5274 52 33.0564 52C41.1798 52 43.5263 41.1954 43.5295 33.0606C43.5295 29.5318 45.6469 27.7675 47.7646 26.0031C49.8823 24.2386 52 22.4743 52 18.9455C52 10.8196 41.1798 8.47012 33.0593 8.47012C29.5305 8.47012 27.7659 6.35261 26.0016 4.23506C24.237 2.11753 22.4726 0 18.9437 0C10.8172 0 8.46763 10.8196 8.46763 18.9396C8.46763 22.4683 6.35073 24.2327 4.23381 25.997C2.11691 27.7615 0 29.5259 0 33.0546C0 41.1804 10.8172 43.53 18.9407 43.53C22.4696 43.53 24.2341 45.6474 25.9985 47.7649ZM26 35.62C31.3131 35.62 35.62 31.3131 35.62 26C35.62 20.687 31.3131 16.38 26 16.38C20.687 16.38 16.38 20.687 16.38 26C16.38 31.3131 20.687 35.62 26 35.62Z",
            "M13.1857 0H0.185715V13C0.185715 19.6201 5.13412 25.0845 11.5339 25.896C5.04439 26.6245 1.09726e-06 32.1303 5.68248e-07 38.8144L0 51.8144H13C19.6201 51.8144 25.0845 46.8658 25.896 40.4661C26.6245 46.9557 32.1303 52 38.8144 52H51.8144V39C51.8144 32.3799 46.8658 26.9155 40.4661 26.104C46.9557 25.3756 52 19.8697 52 13.1857V0.185714L39 0.185714C32.3799 0.185713 26.9155 5.13412 26.104 11.5339C25.3756 5.04439 19.8697 0 13.1857 0Z"
        ],
        duration: 60,
        delay: 500,
        svg_className: "symbol__img"
    }
]
const AboutUsPage = () => {
    const { t } = useTranslation();
    const { updateProgress, show } = useLoading();

    const handleDownload = (url, name) => {
        const link = document.createElement("a");
        link.href = url; // public 폴더 기준 경로 또는 서버 URL
        link.download = name;     // 저장될 이름
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [dArray, setDArray] = useState(symbolData.map(group => group[0]));
    const indexRef = useRef(symbolData.map(() => 0));
    const [isInitalized, setIsInitialized] = useState(false);
    const [loadedImageCount, setLoadedImageCount] = useState(0);
    const length = 3;
    useEffect(() => {

        const animateOne = (i) => {
            const durations = symbolData[i].duration;
            const delays = symbolData[i].delay;
            const currentIndex = indexRef.current[i];
            const nextIndex = (currentIndex + 1) % symbolData[i].content.length;

            // const interp = interpolate(
            //     symbolData[i].content[currentIndex],
            //     symbolData[i].content[nextIndex],
            //     { maxSegmentLength: 2 }
            // );

            let frame = 0;

            const animate = () => {
                const t = frame / durations;
                // const newPath = interp(t);
                // setDArray(prev => {
                //     const updated = [...prev];
                //     updated[i] = newPath;
                //     return updated;
                // });
                frame++;
                if (frame <= durations) {
                    requestAnimationFrame(animate);
                } else {
                    indexRef.current[i] = nextIndex;
                    setTimeout(() => animateOne(i), delays);
                }
            };

            animate();
        };

        // 각 심볼 개별 실행
        symbolData.forEach((symbol, i) => {
            if (symbol.content.length < 2) {
                // content가 하나뿐이면 초기 값만 적용
                setDArray(prev => {
                    const updated = [...prev];
                    updated[i] = symbol.content[0];
                    return updated;
                });
                return;
            }
            animateOne(i);
        });

        show();
        setIsInitialized(true);

    }, []);

    return (
        <div className={styles.page}>
            <Header></Header>
            <TitleText titleTextInfo={{ textKey: "Header.Detail.About.Info" }}></TitleText>
            <div className={styles.about__container}>
                <FadeInSection className={styles.vision__section}>
                    <div className={styles.scetion__text}>
                        <div className={styles.content__title}>
                            <span className={styles.title__text}>
                                VISION
                            </span>
                            <span className={styles.title__description__text}>
                                {t("AboutUs.Vision.Title")}
                            </span>
                        </div>
                        <div className={styles.content__text}>
                            <span className={styles.description__text}>
                                {t("AboutUs.Vision.Desciption")}

                            </span>
                        </div>
                    </div>


                    <div className={styles.character__container}>

                        {isInitalized && <Image loading="eager" src={lay} className={styles.lay__img} onLoad={() => {
                            setLoadedImageCount((prev) => {
                                const updated = prev + 1;
                                setTimeout(() => {
                                    const progressData = updated === length ? 100 : (updated / length) * 100;
                                    updateProgress(progressData);
                                }, 0);
                                return updated;
                            })
                        }} onError={() => {
                            setLoadedImageCount((prev) => {
                                const updated = prev + 1;
                                setTimeout(() => {
                                    const progressData = updated === length ? 100 : (updated / length) * 100;
                                    updateProgress(progressData);
                                }, 0);
                                return updated;
                            })
                        }} alt="lay character" />}
                        {isInitalized && <Image  loading="eager" src={blue} className={styles.blue__img} onLoad={() => {
                            setLoadedImageCount((prev) => {
                                const updated = prev + 1;
                                setTimeout(() => {
                                    const progressData = updated === length ? 100 : (updated / length) * 100;
                                    updateProgress(progressData);
                                }, 0);
                                return updated;
                            })
                        }} onError={() => {
                            setLoadedImageCount((prev) => {
                                const updated = prev + 1;
                                setTimeout(() => {
                                    const progressData = updated === length ? 100 : (updated / length) * 100;
                                    updateProgress(progressData);
                                }, 0);
                                return updated;
                            })
                        }} alt="blue character" />}

                    </div>
                </FadeInSection>
                <FadeInSection className={styles.mission__section}>
                    <div className={styles.scetion__text}>

                        <div className={styles.content__title}>
                            <span className={styles.title__text}>
                                MISSION
                            </span>
                            <span className={styles.title__description__text}>
                                {t("AboutUs.Mission.Title")}
                            </span>
                        </div>
                        <div className={styles.content__text}>
                            <span className={styles.description__text}>
                                {t("AboutUs.Mission.Desciption")}
                            </span>
                        </div>


                    </div>
                    <div className={styles.symbol__container}>

                        {dArray.map((element, symbol_index) => (
                            <svg className={styles[symbolData[symbol_index].svg_className]} key={symbol_index} viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet">
                                <g>
                                    <path d={element} fill="white" className={styles[symbolData[symbol_index].path_className]}>
                                    </path>
                                </g>
                            </svg>
                        ))
                        }
                    </div>
                </FadeInSection>
                <FadeInSection className={styles.work__section}>
                    <div className={styles.scetion__text}>
                        <div className={styles.content__title}>
                            <span className={styles.title__text}>
                                WAY TO WORKS
                            </span>
                            <span className={styles.title__description__text}>
                                {t("AboutUs.Work.Title")}
                            </span>
                        </div>
                        <div className={styles.content__text}>
                            <span className={styles.description__text}>
                                {t("AboutUs.Work.Desciption")}

                            </span>
                        </div>
                    </div>
                </FadeInSection>
                <FadeInSection className={styles.ci__section}>
                    <div className={styles.ci__title}>
                        <span className={styles.title__text}>
                            BePex CI
                        </span>
                    </div>
                    <div className={styles.ci__content}>
                        <div className={styles.logo}>
                            {isInitalized && <Image loading="eager" src={logo} className={styles.logo__img}
                                onLoad={() => {
                                    setLoadedImageCount((prev) => {
                                        const updated = prev + 1;
                                        setTimeout(() => {
                                            const progressData = updated === length ? 100 : (updated / length) * 100;
                                            updateProgress(progressData);
                                        }, 0);
                                        return updated;
                                    })
                                }} onError={() => {
                                    setLoadedImageCount((prev) => {
                                        const updated = prev + 1;
                                        setTimeout(() => {
                                            const progressData = updated === length ? 100 : (updated / length) * 100;
                                            updateProgress(progressData);
                                        }, 0);
                                        return updated;
                                    })
                                }}
                                alt="logo icon"></Image>
                            }
                        </div>

                        <div className={styles.ci__logo__down} >
                            <div className={styles.down__btn} onClick={() => handleDownload("/CI/BePex_Corporate_Identity.ai", "BePex_Corporate_Identity.ai")}>
                                <span className={styles.down__text}>
                                    AI DOWNLOAD
                                </span>
                                <div className={styles.download__btn}>

                                    <Image  loading="eager" src={download} className={styles.download__btn__img} alt="ai download" />
                                </div>
                            </div>
                            <div className={styles.down__btn} onClick={() => handleDownload("/CI/BePex_CI_PNG.zip", "BePex_CI_PNG")}>
                                <span className={styles.down__text}>
                                    PNG DOWNLOAD
                                </span>
                                <div className={styles.download__btn}>
                                    <Image loading="eager" src={download} className={styles.download__btn__img} alt="png download" />
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeInSection>
            </div>
            <Footer></Footer>
        </div>

    );
}

export default AboutUsPage;